import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import MessageAlert from '../common/messageAlert/MessageAlert';
import GuestTopBar from './GuestTopBar';
import GuestCatalogContainer from './GuestCatalogContainer';
import GuestSessionExpiredModal from './GuestSessionExpiredModal';
import * as guestActions from '../../actions/guestActions';
import { getGuestSessionFromStorage, getGuestTokenFromStorage } from '../../shared';
import { hasExpired } from '../../services/jwt/jwtService';

const isGuestTokenValid = () => {
  const token = getGuestTokenFromStorage();
  return Boolean(token) && !hasExpired(token);
};

export class GuestCatalogPage extends React.Component {
  static propTypes = {
    clientName: PropTypes.string,
    hasSession: PropTypes.bool,
    guestActions: PropTypes.object
  };

  componentDidMount() {
    // guest/catalog es una ruta suelta (sin AppWrapper/AuthWrapper), así que a diferencia del resto
    // de puntos de entrada (ver AuthWrapper.jsx) nadie más cierra el loader global que index.html deja
    // activo en toda carga de página completa: sin esto, una recarga se queda con el spinner para siempre
    // aunque el resto de esta lógica termine bien por debajo.
    $('#smartLoader')
      .removeClass('active')
      .removeClass('opaque');
    $('#smartLoader-loader').removeClass('active');

    if (!isGuestTokenValid()) {
      this.props.guestActions.exitGuestSession();
      return;
    }
    // Rehidrata el dominio redux "guest" tras una recarga de página a partir de lo persistido en storage.
    if (!this.props.hasSession) {
      const storedSession = getGuestSessionFromStorage();
      if (storedSession) {
        this.props.guestActions.setSession(storedSession);
      }
    }
  }

  render() {
    const { clientName } = this.props;

    if (!isGuestTokenValid()) {
      return null;
    }

    return (
      <div className="guest-catalog-page">
        <GuestTopBar clientName={clientName} />
        <div className="guest-catalog-body">
          <GuestCatalogContainer />
        </div>
        <GuestSessionExpiredModal />
        <MessageAlert />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { resolvedClient, session } = state.guest;
  const storedSession = getGuestSessionFromStorage();
  return {
    clientName:
      (session && session.clientName) ||
      (resolvedClient && resolvedClient.clientName) ||
      (storedSession && storedSession.clientName) ||
      '',
    hasSession: Boolean(session)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    guestActions: bindActionCreators(guestActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestCatalogPage);
